import { Injectable, ViewChild } from '@angular/core';
//import { CustomUserApi, CustomUser } from '../lbsdk';
import { map } from 'rxjs/operators';

import { EmpresaApi, RolApi, UsuarioRolApi, UsuarioSucursalApi } from '../lbsdk';
import { of } from 'rxjs/observable/of';
import { UsuarioApi } from '../lbsdk';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operator/filter';



@Injectable()
export class AuthService {
    public empresaSeleccionada: number = null;
    constructor(private userService: UsuarioApi, private role: RolApi, private usuarioRolApi: UsuarioRolApi,
        private usuarioSucursalApi: UsuarioSucursalApi, private empresaApi: EmpresaApi) { }

    isLoggedIn() {
        return sessionStorage.getItem('userData') ? true : false;
    }

    isAdministrador() {
        let aux = JSON.parse(sessionStorage.getItem('userData'));
        if (aux) {
            let existe = aux.roles.filter(x => x.idrol == 5)
            if (existe.length == 0) {
                return false;
            } else {
                return true;
            }

        }
        else {
            return false;
        }
    }
    getEmpresaNombre() {
        if (this.empresaSeleccionada) {
            console.log("busca nombre ", this.empresaSeleccionada, " en ", this.empresasUsuario)
            let emp = this.empresasUsuario.find(x => x.idEmpresa == this.empresaSeleccionada)
            return emp.nombreFantasia
        }
    }
    isSuperAdministrador() {
        let aux = JSON.parse(sessionStorage.getItem('userData'));
        if (aux) {

            let existe = aux.roles.filter(x => x.idrol == 7)
            if (existe.length == 0) {
                return false;
            } else {
                return true;
            }

        }
        else {
            return false;
        }
    }

    isOperador() {
        let aux = JSON.parse(sessionStorage.getItem('userData'));
        if (aux) {
            let existe = aux.roles.filter(x => x.idrol == 4)
            if (existe.length == 0) {
                return false;
            } else {
                return true;
            }

        }
        else {
            return false;
        }
    }

    isCliente() {
        let aux = JSON.parse(sessionStorage.getItem('userData'));
        if (aux) {
            let existe = aux.roles.filter(x => x.idrol == 3)
            if (existe.length == 0) {
                return false;
            } else {
                return true;
            }

        }
        else {
            return false;
        }
        //sessionStorage.getItem('userData')['user']['roleName'] == "Cliente" ? true : false;
    }

    login(user, password, remember?) {

        let credentials = { "email": user, "password": password };
        let userLogueado;
        let idEmpresa = [];
        return this.userService.login(credentials)
            .flatMap(res => {
                //BUSCO LOS ROLES DEL USUARIO
                console.log("LOGIN OK ", res)
                userLogueado = res;
                // if (res.statusCode != 200) {
                //     return of({ error: res.error })
                // }
                //TODO: REVISAR
                return this.usuarioRolApi.find({ where: { idusuario: res.user.idusuario } })
                // return this.role.findById(1)//(res.user.roleId)
            })
            .flatMap(roles => {
                console.log("ROLES", roles)
                //BUSCO LAS SUCURSALES DEL USUARIO
                console.log("LOGIN OK ", roles)
                userLogueado['roles'] = roles
                //TODO: REVISAR
                return this.usuarioSucursalApi.find({
                    where: { idusuario: userLogueado.user.idusuario }, include: {
                        relation: "Sucursal", scope: {
                            include: [{ relation: "Empresa" }]
                        }
                    }
                })

                // return this.role.findById(1)//(res.user.roleId)
            })
            .flatMap((res: any) => {
                console.log("RELACION SUCURSALES VER(*) ", res)
                let sucursales = res.map(res => {
                    let Existe = idEmpresa.find(x => x == res.Sucursal.Empresa.idEmpresa)
                    if (Existe == undefined) {
                        idEmpresa.push(res.Sucursal.Empresa.idEmpresa)
                    }
                    return {
                        idsucursal: res.idsucursal, idusuario: res.idusuario,
                        nombre: res.Sucursal.nombre, idempresa: res.Sucursal.Empresa.idEmpresa, razonSocial: res.Sucursal.Empresa.razonSocial
                    }
                })
                return of(sucursales)
            })
            .flatMap((sucursalEmpresa: any) => {
              
                userLogueado['sucursales'] = sucursalEmpresa;

                let rolSuper = userLogueado['roles'].find(x => x.idrol == 7) //TODO SUPER ADMINISTRADOR
                console.log("**************** ROL SUPER ", rolSuper)
                if (rolSuper == undefined) {
                    return this.empresaApi.find({
                        where: {
                            idEmpresa: {
                                inq: idEmpresa
                            }
                        }
                    })
                }
                else {
                    return this.empresaApi.find({ where: { activo: true } })
                }

            })
            .flatMap(res => {
                console.log("*************PUSH DE EMPRESAS ", res)
                // userLogueado.user['roleName'] = res['name'];
                this.empresasUsuario = res;
                this.userData = userLogueado;
                this.userData.user = user;
                return of(userLogueado)
            })
            ._catch(error => {
                return of(error)
            })
        /* .pipe(
             flatMap((data: any) => {

                 this.userData = data;
                 this.userData.user = user;
             })
         )*/
    }

    logout() {
        /* if (this.userData) {
             this.userService.logoutCustom(this.userData.token)
                 .subscribe(data => {
                     console.log("Usuario deslogueado");
                 })
         }*/
        sessionStorage.removeItem('userData');


    }

    set userData(userData: any) {

        sessionStorage.setItem('userData', JSON.stringify(userData));
    }
    get userData() {
        return this.isLoggedIn() ? JSON.parse(sessionStorage.getItem('userData')) : null
    }

    set empresasUsuario(userData: any) {

        sessionStorage.setItem('empresasUsuario', JSON.stringify(userData));
    }
    get empresasUsuario() {
        return this.isLoggedIn() ? JSON.parse(sessionStorage.getItem('empresasUsuario')) : null
    }



}


// WEBPACK FOOTER //
// ./src/services/auth/auth.service.ts